// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerAccountType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    active: boolean;
    sortOrder: number;
    customerManagedAccount: boolean;
}

export class CustomerAccountType implements ICustomerAccountType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public active: boolean;
    public sortOrder: number;
    public customerManagedAccount: boolean;

    /**
		Returns Primary Account CustomerAccountType
	**/
    get PrimaryAccount(): ICustomerAccountType {
        return this.FromId(1);
    }
    /**
		Returns Regular Account CustomerAccountType
	**/
    get RegularAccount(): ICustomerAccountType {
        return this.FromId(2);
    }
    /**
		Returns Business Joint Account CustomerAccountType
	**/
    get BusinessJointAccount(): ICustomerAccountType {
        return this.FromId(3);
    }
    /**
		Returns Personal Joint Account CustomerAccountType
	**/
    get PersonalJointAccount(): ICustomerAccountType {
        return this.FromId(4);
    }
    /**
		Returns Guest Account CustomerAccountType
	**/
    get GuestAccount(): ICustomerAccountType {
        return this.FromId(5);
    }
    /**
		Returns Fuel Tax CustomerAccountType
	**/
    get FuelTax(): ICustomerAccountType {
        return this.FromId(6);
    }
    /**
		Returns Credit Account CustomerAccountType
	**/
    get CreditAccount(): ICustomerAccountType {
        return this.FromId(7);
    }
    /**
		Returns IFTA FUEL TAX CustomerAccountType
	**/
    get IFTAFUELTAX(): ICustomerAccountType {
        return this.FromId(8);
    }
    /**
	Returns Business Trans Credit Account CustomerAccountType
	**/
    get BusinessTransCreditAccount(): ICustomerAccountType {
        return this.FromId(9);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'PrimaryAccount', displayValue: 'Primary Account', description: 'Primary Account generated with the creation of a customer record', active: true, sortOrder: 1, customerManagedAccount: true });
        this._dictionary.add('2', { id: 2, value: 'RegularAccount', displayValue: 'Regular Account', description: 'Account used when a customer wants to create a new account in addition to their primary account', active: true, sortOrder: 2, customerManagedAccount: true });
        this._dictionary.add('3', { id: 3, value: 'BusinessJointAccount', displayValue: 'Business Joint Account', description: 'Joint account dedicated to join business accounts together', active: false, sortOrder: 3, customerManagedAccount: true });
        this._dictionary.add('4', { id: 4, value: 'PersonalJointAccount', displayValue: 'Personal Joint Account', description: 'Joint account dedicated to join personal affairs together', active: false, sortOrder: 4, customerManagedAccount: true });
        this._dictionary.add('5', { id: 5, value: 'GuestAccount', displayValue: 'Guest Account', description: 'Account dedicated to users who request guest access. This account has limited services available to it', active: false, sortOrder: 5, customerManagedAccount: true });
        this._dictionary.add('6', { id: 6, value: 'FuelTax', displayValue: 'Fuel Tax', description: 'Records transactions related to Fuel Tax reports (EXCISE and UST)', active: true, sortOrder: 6, customerManagedAccount: true });
        this._dictionary.add('7', { id: 7, value: 'CreditAccount', displayValue: 'Credit Account', description: 'Records transactions that are to be used as credit during future services', active: true, sortOrder: 7, customerManagedAccount: false });
        this._dictionary.add('8', { id: 8, value: 'IFTA FUEL TAX', displayValue: 'IFTA FUEL TAX', description: 'Records transactions related to Fuel Tax reports (IFTA)', active: true, sortOrder: 8, customerManagedAccount: false });
        this._dictionary.add('9', { id: 9, value: 'BusinessTransCreditAccount', displayValue: 'Business Trans Credit Account', description: 'Records transaction that is dedicated to a specific BTID', active: true, sortOrder: 9, customerManagedAccount: false });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerAccountType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerAccountType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerAccountType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerAccountType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerAccountType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
